<template>
  <div>
    <HeaderView :title="$t('mine.watch')" />
    <div class="view-page mymovie">
      <div class="top">
        <div class="left">
          <div
            class="van-image van-image--round"
            style="width: 60px; height: 60px"
          >
            <img
              src="../../assets/img/home/avatar1.png"
              class="van-image__img"
              style="object-fit: cover"
            />
          </div>
          <div class="center">
            <h1>{{ $t('video.welcome',{name:userInfo.name}) }}</h1>
            <p>{{ $t('video.tickets') }}</p>
          </div>
        </div>
        <div class="right">{{ $t('video.num') }}:0</div>
      </div>
      <div class="item">
        <div class="title">
          <span
            ><img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAiCAYAAAA3WXuFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFRUlEQVRYhZ2YW6hdVxWGv29nW2pytBg9PhSt4osoQitFsGAstqgVC2qjiVBBTUtBgqBUCEVQfFBBqRp88vbgQ0GxtehDEyJNTrw0pUJJqQWxVXxRS3LUVmnEmLN+H9bca8912SdHYR/OmnuOOS7/+MeYY21//tFjmCAgKc9BuEZyO8nNwh7Jr00eFn4muQDBlDOtPCzPYgILneU/lR0mZCDMG2ZoURRQkbxHcr9xN8u9t6qflJw3PCCeijkpbBpbGSWLoFo9BIrjVPtlr8iUTytz8mMnuohKtG8UnirrZyE/NGxK3ix5t2FPhcolkgckPxZOmZzvou/Q7iPS36e3Bpg3znoRSb5e1r+R7CN5rkVQTPZq9os3S24yWUcOigdNtpQfiA9LTiT8qdPZIcJCT+uCi/RWCJ34+MmaB2sm/2y9zTsMG93emGcvEm6BHDC5Sbh6IHesoHta8sc+z5bcI30OefzQBpXR/ZL7gb+ZvHz5fUXeHpFrhXmT4QOS/ZJrl8QOkjMt7/Kg8AdG6az0PnTH6VrxMcktJg8Kt0nmDiqnrqpisBGaak/DPsntkn3AGwY6zkjuAzYkTy0co+zPtzoO5WrxxvL8TsnzxqoCezzr1l20LT8akxc058WLkqvMsprKmRskN0hIfFLzI8lR4z9C8Cd3/grJPslxk90T/Wi8XqZikM4+P5ZVNMVBah1/lXxQsjFvnO2VnDC5UrMp+bT4uw7+RZW44EyFVItmVzlLNBd9aUFk+3vt85b4iiT3aN4unjJ53bzRI8KV4p9bMmazTg/bGZ1KZy2/8jyV0xwPbpjcqHxt3jh7bxG8T9zkfzJKXwY6RxYpo8+fVU4fUR+V3DrfYrZeFD638tAqJ7u/8ZnVgUG/OATzTNmbzxu9VIxeUSnYo7lK0oyqq0ZiwihjNNRsied68tV54IrF+XnjLEVBisFPSL4irknSQ6HnQAbpWImmki2T4+qtw7ZRUjZbnG/vsr7RazRrRaHbO7BDcie7NNePkRmfr8cPi8J7JA+ZrGFymeraNYlMTey2LTaSx5aOtvf7VHHMGx0pJP5iB1EPyD3u4sOKZAdo9saPQsi3aQ6Lu02aFVHPhAviVyWPTzk6lY6d9LM6ZaEtybskH67up20iytPGx1dU1woHVsiUYEvKgCWBP2N8QvPiulcM+wjkXybf//+6+AjxmkOzUkGd4nOae6ea3VJuh9U11bumy77iEC4H8tGIQc/QZfvOiqh33sVT9aG2hS8dwdEhJpycmpG2d2B7nrUc6ryE9O4qVyvuoTHmED0HVl81QyerKqs5Ml1Z1IoZRsrAaVYanexdZT2P7Y3VGmiVZjHddQa7yppIU9/oJM+GTlymD6lp+3Mn3A6XLRJ9LmWcznXh88Z1zCO28zGa2yQHJf8xfkHztOSlJp9TX237an5vuZ62ag7tKvBezCAN3XBewU9/2kN8v8nhds8DJkdLyr4j7i2GnhcPm7xLc3e5ng5ovin5t8nFjkPBF9Ki8MqW1PTSlV7FWRzt8eyn6rrkVSS/rNL5IZP3qRck3y2pPgk5YvIazRnxYnH4uoL6ll+6+y/fEw6R/F14i+T33RtB/Xaw3S8dI9nq+8HZ3pvrUsdZybUmj8zD7Fshh9SXQc4Gvmg4K1yKdm8dWH7J6Lgj6RM70n6q1pAyMTK47RvjTPNayZ2tM6L57LzRx4RPJXxDWBO/nDo97Zze8ajPs0L+QZlnzLPh9dSvwHaq+Ii4MS++H0V+C9yV8HrhJaVHdr2lNjzm2cL4Sp4NrycljeSc4bT6bckzJvwXm3g8AV5f3OgAAAAASUVORK5CYII="
              alt=""
            />
            {{ $t('video.title') }}</span
          >
        </div>
        <van-pull-refresh
          :pulling-text="$t('common.repulling')"
          :loosing-text="$t('common.reloosing')"
          :loading-text="$t('common.reloading')"
          :success-text="$t('common.resuccess')"
          v-model="isLoading"
          @refresh="onRefresh"
        >
          <van-empty
            v-if="list.length === 0"
            :description="$t('withdraw.empty_data')"
          />
          <div v-else class="item_list" v-for="(v, key) in list" :key="key">
            <div
              style="
                text-align: center;
                font-size: 16px;
                font-weight: 700;
                margin: 10px 0;
              "
            >
              {{ v.name }}
            </div>
            <div
              style="
                width: 96%;
                margin: 0px auto;
                border-bottom: 1px solid #e6e6e6;
              "
              v-html="v.text"
            ></div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from "../../components/Header/index.vue";
export default {
  name: "MyWatchView",
  components: { HeaderView },
  data() {
    return {
      isLoading: false,
      list: [],
      userInfo:{}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: "get",
        url: "sys_get_notice_list",
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
          console.log(this.list);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo () {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
          console.log(this.userInfo)
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
    } else {
        this.getUserInfo()
      //this.getUserWithdrawList();
    }
  },
};
</script>
<style lang="scss" scoped>
.mymovie {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
}

.mymovie .top {
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 0.13333rem;
  padding: 3%;
  margin: 1rem auto;
}

.mymovie .top .van-image {
  border: 4px solid #d4d0e6;
}

.mymovie .top .right {
  color: #fff;
  font-size: 0.76667rem;
  padding: 0.46667rem 1rem;
  border-radius: 2rem;
  background: linear-gradient(30deg, #8073eb, #e055a0);
}

.mymovie .top .left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  flex: 1;
}

.mymovie .top .left .center {
  padding-left: 5%;
}

.mymovie .top .left .center > {
  padding: 0.2rem 0;
}

.mymovie .top .left h1 {
  font-size: 0.93333rem;
  color: #48328b;
}

.mymovie .top .left p {
  color: #523e90;
  font-size: 0.76667rem;
}

.mymovie .item {
  width: calc(100% - 10%);
  margin: 1rem auto 0.33333rem;
  background: #fff;
  padding: 5%;
  height: calc(100vh - 220px);
}

.mymovie .item .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mymovie .item .title span {
  font-weight: 600;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #4a338b;
}

.mymovie .item .title span img {
  width: 1.33333rem;
  margin-right: 0.33333rem;
}

.mymovie .item .title a {
  color: #979799;
}
</style>
